import { jsx as _jsx } from "react/jsx-runtime";
import { ComponentTitle } from '../typography';
export const BottomSheetTitle = ({ children, dataTest = 'bottom-sheet-tite', }) => _jsx(ComponentTitle, { dataTest: dataTest, children: children });
